var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v("Liquidación de Compra " + _vm._s(_vm.numero_comprobante))
          ]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "PPR" && _vm.anulado === "N",
                    expression: "estado === 'PPR' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-warning"
              },
              [_c("strong", [_vm._v("PENDIENTE DE AUTORIZACIÓN")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.anulado === "S",
                    expression: "anulado === 'S'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.estado === undefined || _vm.estado === null) &&
                      _vm.anulado === "N" &&
                      !_vm.enColaAutorizacion,
                    expression:
                      "\n            (estado === undefined || estado === null) &&\n            anulado === 'N' &&\n            !enColaAutorizacion\n          "
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("EMITIDO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "AUT" && _vm.anulado === "N",
                    expression: "estado === 'AUT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N" && _vm.anulado === "N",
                    expression: "estado === 'N' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "NAT" && _vm.anulado === "N",
                    expression: "estado === 'NAT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("NO AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.enColaAutorizacion,
                    expression: "enColaAutorizacion"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_c("strong", [_vm._v("PENDIENTE DE ENVÍO AL SRI")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "button",
            {
              staticClass: "btn-bus200 btn--bigger",
              attrs: {
                disabled:
                  !_vm.permiteEliminarComprobante &&
                  !_vm.permiteEditarComprobante &&
                  !_vm.permiteConsultarComprobante,
                type: "button"
              },
              on: { click: _vm.consultarComprobantes }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Buscar comprobantes")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado == "N",
                        expression: "estado == 'N'"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-field select2",
                        class: { "select2--disabled": _vm.estado !== "N" }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "descripcion",
                                  options: _vm.puntosEmision,
                                  id: "punto_emision",
                                  placeholder: "Seleccione..."
                                },
                                model: {
                                  value: _vm.selectedPuntoEmision,
                                  callback: function($$v) {
                                    _vm.selectedPuntoEmision = $$v
                                  },
                                  expression: "selectedPuntoEmision"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "punto_emision" } }, [
                                _vm._v("Punto de emisión *")
                              ]),
                              _vm._v(" "),
                              _vm.errores.id_punto_emision
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.id_punto_emision[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.esElectronico &&
                          _vm.estado === "N",
                        expression:
                          "\n                tipoComprobante !== '00' && !esElectronico && estado === 'N'\n              "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "#########",
                                expression: "'#########'"
                              }
                            ],
                            attrs: {
                              type: "tel",
                              id: "numero_documento",
                              placeholder: "#########"
                            },
                            model: {
                              value: _vm.form.numero_documento,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "numero_documento", $$v)
                              },
                              expression: "form.numero_documento"
                            }
                          },
                          [
                            _c("span", [_vm._v("Número de documento")]),
                            _vm._v(" "),
                            _vm.errores.numero_documento
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.numero_documento[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly:
                                _vm.form.id_cliente !== null &&
                                _vm.form.id_cliente !== "",
                              id: "identificacion",
                              placeholder: "# Identificación"
                            },
                            model: {
                              value: _vm.numero_identificacion,
                              callback: function($$v) {
                                _vm.numero_identificacion = $$v
                              },
                              expression: "numero_identificacion"
                            }
                          },
                          [
                            _c("span", [_vm._v("Identificación *")]),
                            _vm._v(" "),
                            _vm.errores.id_cliente
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.id_cliente[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.id_cliente === null ||
                                  _vm.form.id_cliente === "",
                                expression:
                                  "\n                      form.id_cliente === null || form.id_cliente === ''\n                    "
                              }
                            ],
                            staticClass: "btn-success",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.consultarCliente }
                          },
                          [_c("i", { staticClass: "fa fa-check" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.id_cliente !== null &&
                                  _vm.form.id_cliente !== "",
                                expression:
                                  "\n                      form.id_cliente !== null &&\n                      form.id_cliente !== ''\n                    "
                              }
                            ],
                            staticClass: "btn-danger",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.quitarCliente }
                          },
                          [_c("i", { staticClass: "fa fa-ban" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: "cliente",
                              placeholder: "Nombre de proveedor"
                            },
                            model: {
                              value: _vm.nombre_cliente,
                              callback: function($$v) {
                                _vm.nombre_cliente = $$v
                              },
                              expression: "nombre_cliente"
                            }
                          },
                          [_c("span", [_vm._v("Proveeedor *")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-info",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.consultarPersonas }
                          },
                          [_c("i", { staticClass: "fa fa-search" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            disabled: !_vm.editable,
                            type: "date",
                            format: "dd-MM-yyyy",
                            id: "fecha_emision",
                            lang: "es"
                          },
                          nativeOn: {
                            keyup: function($event) {
                              return _vm.actualizarFechaVencimiento.apply(
                                null,
                                arguments
                              )
                            }
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: !_vm.editable,
                            id: "email",
                            placeholder: "Correo del cliente"
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v('E-mail ("," para separar varios)')
                          ]),
                          _vm._v(" "),
                          _vm.errores.email
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.email[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            id: "clave_acceso",
                            placeholder: "################"
                          },
                          model: {
                            value: _vm.clave_acceso,
                            callback: function($$v) {
                              _vm.clave_acceso = $$v
                            },
                            expression: "clave_acceso"
                          }
                        },
                        [_c("span", [_vm._v("Clave de acceso")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            disabled: "",
                            type: "datetime",
                            format: "dd-MM-yyyy HH:mm:ss",
                            id: "fecha_autorizacion",
                            lang: "es"
                          },
                          model: {
                            value: _vm.form.fecha_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_autorizacion", $$v)
                            },
                            expression: "form.fecha_autorizacion"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_autorizacion" } }, [
                          _vm._v("Fecha de autorización *")
                        ])
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            placeholder: "#############",
                            id: "numero_autorizacion"
                          },
                          model: {
                            value: _vm.form.numero_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "numero_autorizacion", $$v)
                            },
                            expression: "form.numero_autorizacion"
                          }
                        },
                        [_c("span", [_vm._v("N° Autorización")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled": !_vm.editable
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "descripcion",
                              options: _vm.monedas,
                              id: "moneda",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.selectedMoneda,
                              callback: function($$v) {
                                _vm.selectedMoneda = $$v
                              },
                              expression: "selectedMoneda"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "moneda" } }, [
                            _vm._v("Moneda *")
                          ]),
                          _vm._v(" "),
                          _vm.errores.id_moneda
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.id_moneda[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "descripcion",
                              options: _vm.tiposEmision,
                              id: "tipo_emision",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.selectedTipoEmision,
                              callback: function($$v) {
                                _vm.selectedTipoEmision = $$v
                              },
                              expression: "selectedTipoEmision"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tipo_emision" } }, [
                            _vm._v("Tipo de emisión *")
                          ]),
                          _vm._v(" "),
                          _vm.errores.id_tipo_emision
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.id_tipo_emision[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.no_anular_consumidor_final_aut
                  ? _c("div", { staticClass: "col-xs-12" }, [_vm._m(1)])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__title" }, [
              _c(
                "div",
                { staticClass: "form-inline my-0" },
                [
                  _c("h5", [_vm._v("Detalles del comprobante")]),
                  _vm._v(" "),
                  _c(
                    "input-field",
                    {
                      staticClass: "my-0",
                      staticStyle: {
                        width: "300px",
                        "flex-direction": "row-reverse"
                      },
                      attrs: {
                        stretch: "",
                        id: "searchItems",
                        placeholder: "Consulta de detalle por descripción..."
                      },
                      model: {
                        value: _vm.searchItems,
                        callback: function($$v) {
                          _vm.searchItems = $$v
                        },
                        expression: "searchItems"
                      }
                    },
                    [_c("span", [_c("i", { staticClass: "fa fa-search" })])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card__controls" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione un item...",
                          id: "item",
                          options: _vm.items,
                          label: "descripcion_item"
                        },
                        on: { search: _vm.onSearchItems, input: _vm.inputItem },
                        model: {
                          value: _vm.selectedItem,
                          callback: function($$v) {
                            _vm.selectedItem = $$v
                          },
                          expression: "selectedItem"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("tabla-detalle-comprobante", {
                  ref: "tablaDetalleComprobante",
                  attrs: {
                    tipo: "E",
                    disabled: !_vm.editable,
                    anulado: _vm.anulado,
                    tipoComprobante: _vm.tipoComprobante,
                    errores: _vm.errores,
                    irbpnr: _vm.irbpnr,
                    search: _vm.searchItems,
                    decimales_compras: _vm.precision
                  },
                  on: { input: _vm.inputDetalles },
                  model: {
                    value: _vm.form.items,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "items", $$v)
                    },
                    expression: "form.items"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("tabla-forma-pago", {
                  attrs: {
                    tiposUnidad: _vm.tiposUnidad,
                    disabled: !_vm.editable,
                    totalComprobante: _vm.form.total,
                    errores: _vm.errores,
                    formasPago: _vm.formasPago
                  },
                  on: { updatedFormaPago: _vm.inputFormasPago },
                  model: {
                    value: _vm.form.formasPago,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "formasPago", $$v)
                    },
                    expression: "form.formasPago"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-xs-12 col-md-7" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-informacion-adicional", {
                      attrs: {
                        enviable: "",
                        disabled: !_vm.editable,
                        errores: _vm.errores
                      },
                      model: {
                        value: _vm.form.informacionAdicional,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "informacionAdicional", $$v)
                        },
                        expression: "form.informacionAdicional"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-5" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_sin_impuestos",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_sin_impuestos,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_sin_impuestos", $$v)
                                },
                                expression: "form.total_sin_impuestos"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal S/I\n                      "
                              ),
                              _vm.errores.total_sin_impuestos
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.total_sin_impuestos[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "descuento_total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.descuento_total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "descuento_total", $$v)
                                },
                                expression: "form.descuento_total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Descuento total\n                      "
                              ),
                              _vm.errores.descuento_total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.descuento_total[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_no_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_no_sujeto_iva,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "subtotal_no_sujeto_iva",
                                    $$v
                                  )
                                },
                                expression: "form.subtotal_no_sujeto_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal N/IVA\n                      "
                              ),
                              _vm.errores.subtotal_no_sujeto_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .subtotal_no_sujeto_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_e_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_exento_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_exento_iva", $$v)
                                },
                                expression: "form.subtotal_exento_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal E/I\n                      "
                              ),
                              _vm.errores.subtotal_exento_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.subtotal_exento_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total_irbpnr",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_irbpnr,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_irbpnr", $$v)
                                },
                                expression: "form.total_irbpnr"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total IRBPNR\n                      "
                              ),
                              _vm.errores.total_irbpnr
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.total_irbpnr[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva", $$v)
                                },
                                expression: "form.subtotal_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA\n                      "
                              ),
                              _vm.errores.subtotal_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva_0",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva_0,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva_0", $$v)
                                },
                                expression: "form.subtotal_iva_0"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA 0%\n                      "
                              ),
                              _vm.errores.subtotal_iva_0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva_0[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "iva", $$v)
                                },
                                expression: "form.iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      IVA\n                      "
                              ),
                              _vm.errores.iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.iva[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "ice",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.ice,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ice", $$v)
                                },
                                expression: "form.ice"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      ICE\n                      "
                              ),
                              _vm.errores.ice
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.ice[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total", $$v)
                                },
                                expression: "form.total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total\n                      "
                              ),
                              _vm.errores.total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.total[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "PPR" &&
                        _vm.anulado !== "S" &&
                        _vm.selectedPuntoEmision != null,
                      expression:
                        "\n              estado !== 'PPR' &&\n              anulado !== 'S' &&\n              selectedPuntoEmision != null\n            "
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      (!_vm.permiteEditarComprobante && _vm.estado !== "N") ||
                      (_vm.estado === "N" && !_vm.permiteCrearComprobante) ||
                      _vm.enColaAutorizacion,
                    type: "button"
                  },
                  on: { click: _vm.guardarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: {
                    disabled: !_vm.permiteCrearComprobante,
                    type: "button"
                  },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.anulado === "N" &&
                        _vm.selectedPuntoEmision != null,
                      expression:
                        "\n              estado !== 'N' &&\n              anulado === 'N' &&\n              selectedPuntoEmision != null\n            "
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: {
                    disabled: !_vm.permiteEliminarComprobante,
                    type: "button"
                  },
                  on: { click: _vm.anularComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.anulado === "S" &&
                        _vm.estado === "AUT" &&
                        _vm.esElectronico,
                      expression:
                        "anulado === 'S' && estado === 'AUT' && esElectronico"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  attrs: {
                    disabled: !_vm.permiteEliminarComprobante,
                    type: "button"
                  },
                  on: { click: _vm.enviarComprobantesAnulados }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar comprobante anulado")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-bus200 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirPDF }
                },
                [
                  _c("i", { staticClass: "fa fa-file-pdf-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("RIDE")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v("Anterior\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v("Siguiente\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "AUT" && _vm.intento_correo,
                      expression: "estado === 'AUT' && intento_correo"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.enviarCorreo }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar correo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirLogs }
                },
                [
                  _c("i", { staticClass: "fa fa-file-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Logs")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        (_vm.estado === undefined || _vm.estado === null) &&
                        _vm.anulado === "N" &&
                        !_vm.enColaAutorizacion,
                      expression:
                        "\n              estado !== 'N' &&\n              (estado === undefined || estado === null) &&\n              anulado === 'N' &&\n              !enColaAutorizacion\n            "
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.autorizar }
                },
                [
                  _c("i", { staticClass: "fa fa-paper-plane" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Autorizar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.tipoComprobante === "01" &&
                        _vm.permiteClonar,
                      expression:
                        "\n              estado !== 'N' && tipoComprobante === '01' && permiteClonar\n            "
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.clonar }
                },
                [
                  _c("i", { staticClass: "fa fa-clone" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Clonar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.mostrarAuditorias }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Auditorías")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "85%",
            height: "auto",
            scrollable: "",
            name: "listaComprobantes"
          }
        },
        [
          _c("lista-comprobantes", {
            attrs: { tipoComprobante: _vm.tipoComprobanteConsulta },
            on: { selected: _vm.selectedComprobante }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "listaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { tipoFiltro: "C", filterStatus: false },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            scrollable: "",
            width: "70%",
            height: "auto",
            name: "persona"
          }
        },
        [
          _c("persona", {
            attrs: {
              correoPersona: _vm.form.email,
              nombrePersona: _vm.nombre_cliente,
              tipoFiltro: "P",
              numeroIdentificacion: _vm.numero_identificacion,
              searchButton: false
            },
            on: { saved: _vm.savedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "auditorias",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("auditorias", {
            ref: "auditorias",
            attrs: { id_comprobante: _vm.id_comprobante },
            on: { cancelar: _vm.cancelarAuditorias }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noti-info" }, [
      _c("p", [
        _c("i", { staticClass: "fa fa-info-circle" }),
        _vm._v(
          "\n                  Recuerda enviar tus comprobantes electrónicos el mismo día de su emisión para evitar sanciones. según lo establece la resolución NAC-DGERCGC25-00000014.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Forma de pago")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales del comprobante")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ee1818f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee1818f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/LiquidacionCompra.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ee1818f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/LiquidacionCompra.vue
// module chunks = 0